const LOCALE_BY_LANGUAGE = {
  es: 'es-MX',
  en: 'en-US'
};

export const formatMonthYear = (date, language) => {
  const locale = LOCALE_BY_LANGUAGE[language] || LOCALE_BY_LANGUAGE.es;
  return date.toLocaleDateString(locale, { month: 'long', year: 'numeric' });
};

export default formatMonthYear;
